// Require dotenv
require('dotenv').config()

// Loading libraries
import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueToastr from 'vue-toastr'
import VueSession from 'vue-session'
import moment from 'moment'

// Layouts
import Default from '@/layouts/Default.vue'
import JSON from '@/layouts/JSON.vue'

// Custom CSS overrides
import './assets/css/style.css'

// Third party libraries
import axios from 'axios'
import '@fortawesome/fontawesome-pro/css/all.css' // Ensure you are using css-loader

// VueX Store
import store from './store'

// Activate Vue plugins
Vue.use(VueSession)
Vue.use(VueToastr)
Vue.use(vuetify, {
  iconfont: 'fa'
})

Vue.component('default-layout', Default)
Vue.component('json-layout', JSON)

Vue.config.productionTip = false

// Global Axios config
const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL
}

const api = axios.create(axiosConfig)

// If an unauthorised response is returned from the API show login screen.
api.interceptors.response.use((response) => response, (err) => {
  if(err.response.status == 401) {
    window.location.replace('/login')
  } else {
    throw err
  }
})

Object.defineProperty(Vue.prototype, '$axios', { value: api })

// Activate third party libraries
Object.defineProperty(Vue.prototype, '$moment', {value: moment })

// Global Vue filters
Vue.filter('date', function(value) {
  return moment.unix(value / 1000).format('YYYY-MM-DD hh:mm:ss')
})
Vue.filter('ago', function(value){
  return moment(value).fromNow()
})

// Create Vue object
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
